import { PropsWithChildren, useCallback } from 'react';
import cn from 'classnames';

import { useDispatcher, useSelector } from 'app/store/utils/redux/hooks';
import { useAppContext } from 'app/lib/AppContext';

import { ReactComponent as ReplayIcon } from 'assets/icons/icon-replay-gray.svg';
import { ReactComponent as ShareIcon } from 'assets/icons/icon-share-gray.svg';

import Analytics from 'app/lib/Analytics/Analytics';
import styles from './Toolbar.module.css';

const Toolbar = (props: PropsWithChildren) => {
  const actions = useDispatcher();
  const { mode } = useAppContext();
  const isPreview = mode === 'preview';

  const show = useSelector((state) => {
    return state.card.pages[state.flipbook.currentPage]?.type === 'PageEnd';
  });

  const handleReplay = useCallback(() => {
    Analytics.track().tappedWatchAgain();
    window.location.reload();
  }, []);

  const handleShare = useCallback(() => {
    actions.share.setOpenShare();
  }, [actions]);

  return (
    <div className={cn(styles.toolbar, { [styles.show]: show })}>
      <div>
        <button data-action="replay" type="button" onClick={handleReplay}>
          <i>
            <ReplayIcon />
          </i>
          <span>replay</span>
        </button>
      </div>
      <div>
        {!isPreview && (
          <button data-action="share" type="button" onClick={handleShare}>
            <span>share this card</span>
            <i>
              <ShareIcon />
            </i>
          </button>
        )}
      </div>
    </div>
  );
};

export default Toolbar;
